import { render, staticRenderFns } from "./frontBackaAppraisal.vue?vue&type=template&id=1a3342b1&scoped=true&"
import script from "./frontBackaAppraisal.vue?vue&type=script&lang=js&"
export * from "./frontBackaAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./frontBackaAppraisal.vue?vue&type=style&index=0&id=1a3342b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3342b1",
  null
  
)

export default component.exports